export default __webpack_public_path__ + "static/media/Crypto1.ead114c2.jpeg";